import _ from 'lodash/fp';
import { createReducer } from 'reduxsauce';
import { COMMENTS, LIKES, ID } from 'actions/Base';

const item = {
  size: 5,
  number: 0,
  content: [],
  last: false,
  first: false,
  isLoading: false,
};

export const INITIAL_STATE = {
  list: {},
  isLoading: false,
};

export const onGetCommentsRequest = (state, { payload }) => {
  const current = _.cloneDeep({ ...item, ...(_.get(ID(payload))(state) || {}) });
  current.isLoading = true;
  return _.set(ID(payload), current)(state);
};

export const onGetCommentsFailure = (state, { payload }) => {
  const current = _.cloneDeep({ ...item, ...(_.get(ID(payload))(state) || {}) });
  current.isLoading = false;
  return _.set(ID(payload), current)(state);
};

export const onGetCommentsSuccess = (state, { payload }) => {
  const current = _.cloneDeep(_.get(ID(payload))(state) || {});
  const content = Object.values([...current.content, ...payload.content], {}).reduce((unique, o) => {
          if(!unique.some(obj => obj.commentId === o.commentId)) {
            unique.push(o);
          }
          return unique;
      },[]);
  return _.set(ID(payload), { ...payload, content, isLoading: false })(state);
};

export const onCreateCommentFailure = (state, { payload }) => {
  const current = _.cloneDeep({ ...item, ...(_.get(ID(payload))(state) || {}) });
  current.isLoading = false;
  return _.set(ID(payload), current)(state);
};

export const onCreateCommentSuccess = (state, { payload }) => {
  const current = _.cloneDeep({ ...item, ...(_.get(ID(payload))(state) || {}) });  
  current.isLoading = false;

  // Add numberOfComments to parent
  if(!!payload.parentEntityId && !!payload.parentEntityType) {
    const parentEntityContent = state[ID({ entityType: payload.parentEntityType, entityId: payload.parentEntityId })].content
    const parentEntityCommentIndex = parentEntityContent.findIndex((comment) => (
      (comment || {}).id === payload.entityId &&
      comment.targetEntityType === payload.targetEntityType
    ));
    parentEntityContent[parentEntityCommentIndex].numberOfComments += 1
  }
  else {
    current.numberOfComments += 1
  }

  return _.set(ID(payload), { ...current, content: [payload, ...current.content] })(state);
};

export const onDeleteCommentSuccess = (state, { payload }) => {
  const current = _.cloneDeep(_.get(ID(payload))(state));

  if (!current) {
    return state;
  }

  current.isLoading = false;
  current.totalElements -= 1;
  
  return _.set(ID(payload), { 
    ...current, 
    content: (current.content || []).filter((cm) => cm.commentId !== payload.commentId) 
  })(state);
};

export const onLikeCommentCreate = (state, { payload }) => {
  // Check if payload.item is present, this is checked due to its needed only for like on comment
  if(payload.item) {
    const commentId = ID(payload.item);

    const feedIndex = state[commentId].content.findIndex((comment) => (
      (comment || {}).id === payload.item.id &&
      comment.targetEntityType === payload.item.targetEntityType
    ));
    
    if (feedIndex > -1) {
      const current = _.cloneDeep(_.get(`[${commentId}].content.[${feedIndex}]`)(state) || {});

      if (current) {
        current.topLikes = _.cloneDeep(current.topLikes || []);
        current.topLikes.push(payload);
        current.numberOfLikes = current.numberOfLikes+1;
        current.loggedInUserLiked = true;

        return _.set(`[${commentId}].content.[${feedIndex}]`, current)(state);
      }
    }
  }
  return state;
};

export const onLikeCommentDelete = (state, { payload }) => {
  // Check if payload.item is present, this is checked due to its needed only for like on comment
  console.log('payload', payload)
  if(payload.item) {
    const commentId = ID(payload.item);

    const feedIndex = state[commentId].content.findIndex((comment) => (
      (comment || {}).id === payload.item.id &&
      comment.targetEntityType === payload.item.targetEntityType
    ));

    if (feedIndex > -1) {
      const current = _.cloneDeep(_.get(`[${commentId}].content.[${feedIndex}]`)(state) || {});

      if (current) {
        current.topLikes = (current.topLikes || []).filter((like) => like.student.studentId !== payload.item.student.studentId);
        current.numberOfLikes = current.numberOfLikes-1;
        current.loggedInUserLiked = false;

        return _.set(`[${commentId}].content.[${feedIndex}]`, current)(state);
      }
    }
  }
  return state;
};

export const ACTION_HANDLERS = {
  [LIKES.DELETE_SUCCESS]: onLikeCommentDelete,
  [LIKES.CREATE_SUCCESS]: onLikeCommentCreate,
  [COMMENTS.GET_REQUEST]: onGetCommentsRequest,
  [COMMENTS.GET_FAILURE]: onGetCommentsFailure,
  [COMMENTS.GET_SUCCESS]: onGetCommentsSuccess,
  [COMMENTS.CREATE_FAILURE]: onCreateCommentFailure,
  [COMMENTS.CREATE_SUCCESS]: onCreateCommentSuccess,
  [COMMENTS.DELETE_SUCCESS]: onDeleteCommentSuccess,
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
